import React from "react";
import type { IOrganizationPageTab } from "../../../SharedPages/OrganizationPage/OrganizationPage";
import { OrganizationPage } from "../../../SharedPages/OrganizationPage/OrganizationPage";
import { useAuthContext } from "../../../../components/Auth";
import { useAuthenticatedUser } from "../../../../hooks/useAuthenticatedUser";
import { SettingsIcon, UserIcon } from "../../../../components/Icons/Icons";
import { CompanyInfo } from "../../../SharedPages/OrganizationPage/CompanyInfo/CompanyInfo";
import { ManageUsersList } from "../../../SharedPages/OrganizationPage/UsersList/UsersList";

export const SellerAdminOrganization = () => {
  const user = useAuthenticatedUser();
  const { roleIsSellerAdmin } = useAuthContext();

  const tabs: IOrganizationPageTab[] = React.useMemo(() => {
    // Only seller admin has "HR rights" to CRUD users
    if (roleIsSellerAdmin) {
      return [
        {
          label: "Company Info",
          icon: SettingsIcon,
          component: <CompanyInfo user={user} />,
        },
        {
          label: "Users",
          icon: UserIcon,
          component: <ManageUsersList user={user} />,
        },
      ];
    } else {
      return [
        {
          label: "Company Info",
          icon: SettingsIcon,
          component: <CompanyInfo user={user} />,
        },
      ];
    }
  }, [user, roleIsSellerAdmin]);

  return <OrganizationPage tabs={tabs} />;
};
